import React, { useEffect } from "react";
import "./plans.css";
import AOS from "aos";
import "aos/dist/aos.css";

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="#aaaaaa45"
    stroke="#aaa"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, marginTop: "2px" }}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <polyline points="7 12 10.5 15.5 17 9" />
  </svg>
);

const PlansSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: false });
    AOS.refresh();
  }, []);

  return (
    <section id="plans" className="plans-section">
      <div className="plans-container">
        {/* Header */}
        <div className="plans-header">
          <p className="plans-label">Planos</p>
          <h1 className="plans-title">
            Planos flexíveis para todos
            <br />
            <span className="plans-title-highlight">os tipos de anfitriões</span>
          </h1>
          <p className="plans-description">Planos Premium</p>
        </div>

        {/* Cards */}
        <div className="plans-cards" data-aos="fade-up">

          {/* Card 1 - Gestão Online */}
          <div className="plan-card">
            <h2 className="plan-name">Gestão Online</h2>

            <div className="plan-price-row">
              <span className="plan-price">10%</span>
              <span className="plan-price-note">+ IVA POR<br />RESERVA</span>
            </div>

            <ul className="plan-feature-list">
              {[
                {
                  title: "ESTRATÉGIA E RENTABILIDADE",
                  desc: "Auditoria de rentabilidade e desenvolvimento de uma estratégia de aluguer de curta duração.",
                },
                {
                  title: "IMAGEM E PROMOÇÃO",
                  desc: "Fotografia profissional, criação e otimização de anúncios e gestão multicanal (Airbnb, Booking, etc.).",
                },
                {
                  title: "GESTÃO DE RESERVAS DIGITAIS",
                  desc: "Comunicação e seleção de hóspedes, gestão de calendários e pagamentos.",
                },
                {
                  title: "GESTÃO INTELIGENTE",
                  desc: "Preços dinâmicos com algoritmo e monitorização personalizada pelo gestor de conta.",
                },
              ].map((item, i) => (
                <li key={i} className="plan-feature-item">
                  <CheckIcon />
                  <div>
                    <strong className="feature-title-plan">{item.title}</strong>
                    <p className="feature-desc">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <button className="plan-button" onClick={() => {
            const el = document.getElementById("contacts");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>COMEÇAR</button>
          </div>

          {/* Card 2 - Gestão Completa (Featured) */}
          <div className="plan-card plan-card--featured">
            <h2 className="plan-name plan-name--featured">Gestão<br />Completa</h2>

            <div className="plan-price-row">
              <span className="plan-price plan-price--featured">20%</span>
            </div>
            <p className="plan-price-sub">+ IVA POR RESERVA</p>

            {/* Includes badge */}
            <div className="plan-includes">
              <span className="plan-includes-label">Gestão Online</span>
            </div>
            <div className="plan-plus-icon">+</div>

            <ul className="plan-feature-list">
              {[
                {
                  title: "FECHADURA ELETRÓNICA",
                  desc: "Instalação de fechaduras eletrónicas, sempre que possível.",
                },
                {
                  title: "OPERAÇÕES DIÁRIAS",
                  desc: "Comunicação com os hóspedes, gestão de calendários e pagamentos, check-in automático, limpeza e lavandaria profissional.",
                },
                {
                  title: "MANUTENÇÃO E CONFORTO",
                  desc: "Fornecimento de toalhas e roupa de cama, lavandaria, comodidades premium, gestão de cauções e visitas de controlo de qualidade.",
                },
                {
                  title: "GESTÃO ADMINISTRATIVA",
                  desc: "Serviço ao hóspede 24/7, emissão de faturas, emissão de SAFT, envio da taxa turística, comunicação ao SEF.",
                },
              ].map((item, i) => (
                <li key={i} className="plan-feature-item">
                  <CheckIcon />
                  <div>
                    <strong className="feature-title-plan">{item.title}</strong>
                    <p className="feature-desc">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <button className="plan-button plan-button--featured" onClick={() => {
            const el = document.getElementById("contacts");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>COMEÇAR</button>
          </div>

          {/* Card 3 - Plano Adicional */}
          <div className="plan-card">
            <h2 className="plan-name">Plano Adicional</h2>

            <div className="plan-price-row">
              <span className="plan-price">+3%</span>
              <span className="plan-price-note">+ IVA POR<br />RESERVA</span>
            </div>

            <ul className="plan-feature-list plan-feature-list--simple">
              {[
                "Assistência no local durante o check-in dos hóspedes;",
                "Envio da SAFT (Declaração de Ativos Financeiros) ao Portal Financeiro;",
                "Assistência com serviços de manutenção e construção;",
                "Visitas regulares à propriedade;",
                "Apoio na gestão do condomínio.",
              ].map((item, i) => (
                <li key={i} className="plan-feature-item plan-feature-item--simple">
                  <CheckIcon />
                  <span className="feature-desc">{item}</span>
                </li>
              ))}
            </ul>

            <button className="plan-button"  onClick={() => {
            const el = document.getElementById("contacts");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>COMEÇAR</button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PlansSection;